module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.session.scheduler && !_vm.session.showScheduler) ? _c('a', {
    staticClass: "btn-group pull-right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.show()
      }
    }
  }, [_vm._v("\n" + _vm._s(_vm.session.scheduler.type.name) + " "), _c('icon', {
    attrs: {
      "name": "external-link"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b70b908!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workbench/simulator/schedulerPanel/SchedulerShortcut.vue
// module id = 1542
// module chunks = 2